const initialState = {
  pendingForm: {
    orderId: "",
    invoiceNo: "",
    statusCode: "",
    minAmount: "",
    maxAmount: "",
    startDate: "",
    endDate: "",
  },
};

const pendingReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_PENDING_FORM":
      return {
        ...state,
        pendingForm: action.payload,
      };
    default:
      return state;
  }
};

export default pendingReducer;
